import MainPage from './main';
import Edit from './edit';
import Import from './import';
import CalendarView from './view';

const routes = [
    {
        path: '/*',
        Component: MainPage,
        props: {},
    },
    {
        path: '/import',
        Component: Import,
    },
    {
        path: '/:id/edit',
        Component: Edit,
        props: {},
    },
    {
        path: '/:id',
        Component: CalendarView,
        props: {},
    },
    {
        path: '/new',
        Component: Edit,
        props: {
            isNew: true,
        },
    },
];

export default routes;
